import { groupArrayByKeys } from '@campus/utils';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SurveyAnswerInterface } from '../../+models/SurveyAnswer.interface';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './survey-answer.reducer';

export const selectSurveyAnswerState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectSurveyAnswerState, (state: State) => state.error);

export const getLoaded = createSelector(selectSurveyAnswerState, (state: State) => state.loaded);

export const getAll = createSelector(selectSurveyAnswerState, selectAll);

export const getCount = createSelector(selectSurveyAnswerState, selectTotal);

export const getIds = createSelector(selectSurveyAnswerState, selectIds);

export const getAllEntities = createSelector(selectSurveyAnswerState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * surveyAnswer$: SurveyAnswerInterface[] = this.store.pipe(
    select(SurveyAnswerQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectSurveyAnswerState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * surveyAnswer$: SurveyAnswerInterface = this.store.pipe(
    select(SurveyAnswerQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectSurveyAnswerState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const getBySurveyQuestionId = createSelector(
  getAll,
  (surveyAnswers: SurveyAnswerInterface[]) =>
    groupArrayByKeys(surveyAnswers, ['surveyQuestionId']) as Dictionary<SurveyAnswerInterface[]>
);
